import { createReducer } from 'typesafe-actions';
import {
  apiBandwidthCalculated,
  apiRequestsCalculated,
  assetBandwidthCalculated,
  type BillingAction
} from './actions.js';
import type { NAME } from './constants.js';

export type BillingState = {
  assetBandwidth?: number;
  apiBandwidth?: number;
  apiRequests?: number;
};

export type BillingSlice = {
  [NAME]: BillingState;
};

export const initialState: BillingState = {};

export default createReducer<BillingState, BillingAction>(initialState)
  .handleAction(assetBandwidthCalculated, (state, action) => {
    return {
      ...state,
      assetBandwidth: action.payload.total
    };
  })
  .handleAction(apiBandwidthCalculated, (state, action) => {
    return {
      ...state,
      apiBandwidth: action.payload.total
    };
  })
  .handleAction(apiRequestsCalculated, (state, action) => {
    return {
      ...state,
      apiRequests: action.payload.total
    };
  });
